import axios from "../axios"

const list = (params = null) => {
    return axios
        .get(`/applicant/notifications`, { params: params })
        .then(response => response.data)
}

const count = () => {
    return axios
        .get(`/applicant/notifications/unread-count`)
        .then(response => response.data)
}

const read = (id) => {
    return axios
        .post(`/applicant/notifications/${id}/read`)
        .then(response => response.data)
}

const readAll = () => {
    return axios
        .post(`/applicant/notifications/read-all`)
        .then(response => response.data)
}

export default {
    list,
    count,
    read,
    readAll,
}